import { useState } from "react";
import StaticHeaderInfo from "components/pages/web/static/staticHeaderInfo";
import { useTranslation } from "react-i18next";
import {
  NavLink,
  Card,
  CardBody,
  CardImg,
  CardTitle,
  Col,
  Container,
  Nav,
  NavItem,
  Row,
  TabContent,
  TabPane,
  UncontrolledCollapse,
} from "reactstrap";
import { isMobile } from "react-device-detect";
import Collapse from "components/pages/web/static/collapse";
import FAQItems from "fixtureData/faq";
import contact from "assets/image/contact-us.png";
import ContactUs from "assets/image/contact-us-mobile.png";
import cn from "classnames";
import "assets/styles/components/lists.scss";

function Faq() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("0");
  const [indexTab, setIndexTab] = useState("0");
  const [indexMobile, setIndexMobile] = useState("0");

  const toggle = (tab: any) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div className="faq_parent">
      <StaticHeaderInfo>
        <div className="mb-5">
          <span className="text-light fs-2 fw-bold ">
            {t("Answer to Frequently Asked Questions")}
          </span>
        </div>
      </StaticHeaderInfo>
      <Container>
        {isMobile ? (
          <>
            <Row>
              <Col xs="12" className="tab-style mb-2 mt-n5">
                <div className="d-flex border-radius-1 flex-column justify-content-between ">
                  {FAQItems.map((i) => (
                    <Card
                      className={cn(
                        "shadow  py-2  mb-2 ",
                        i.id == indexMobile ? "card-select-br " : ""
                      )}
                      onClick={(e) => setIndexMobile(i.id)}
                    >
                      <div
                        className=" d-flex flex-row  justify-content-between align-items-center"
                        id={i.toggler}
                      >
                        <img
                          src={require(`assets/image/${i.src}.png`).default}
                          alt="user icon"
                          width={41}
                        />
                        <span>{t(i.questionTitle)}</span>
                        <i className="icon-circle-down " />
                      </div>
                      <UncontrolledCollapse toggler={`#${i.toggler}`}>
                        <div className="mt-3">
                          <Collapse
                            items={i}
                            questionsArray={i.array}
                            title={t(i.answerTitle)}
                          />
                        </div>
                      </UncontrolledCollapse>
                    </Card>
                  ))}
                </div>
              </Col>
            </Row>
          </>
        ) : (
          <>
            <Row>
              {FAQItems.map((item, index: any) => {
                return (
                  <Col xs="12" sm="12" md="12" lg="2" xl="2" className="mt-n5">
                    <Card
                      className={cn(
                        "shadow border-radius-1 d-flex justify-content-center",
                        item.id == indexTab ? "card-active" : ""
                      )}
                      onClick={() => {
                        toggle(item.id);
                        setIndexTab(index);
                      }}
                    >
                      <div className="style-nav-tab nav faq-box-height d-flex justify-content-center list ">
                        <Nav tabs className="none-border-bottom ">
                          <NavItem className="">
                            <NavLink
                              className={cn(
                                " d-flex flex-column align-items-center justify-content-around",
                                { active: activeTab === item.id }
                              )}
                              onClick={() => {
                                toggle(item.id);
                                setIndexTab(index);
                              }}
                            >
                              <img
                                className="pb-4"
                                src={
                                  require(`assets/image/${item.src}.png`)
                                    .default
                                }
                                alt="user icon"
                              />
                              <div className="fs-6 fw-medium text-secondary-seven-light">
                                {" "}
                                {t(item.questionTitle)}
                              </div>
                            </NavLink>
                          </NavItem>
                        </Nav>
                      </div>
                    </Card>
                  </Col>
                );
              })}
            </Row>
            <Row>
              <Col xs="12" className="my-3">
                <Card className="shadow none-padding card--borderdless border-radius-1 ">
                  <CardBody>
                    <TabContent activeTab={activeTab}>
                      {FAQItems.map((i) => (
                        <TabPane tabId={i.id == indexTab ? i.id : ""}>
                          <Row>
                            <Col sm="12">
                              <Collapse
                                questionsArray={i.array}
                                title={t(i.answerTitle)}
                              />
                            </Col>
                          </Row>
                        </TabPane>
                      ))}
                    </TabContent>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </>
        )}
        <Row className="pt-5 none-padding">
          <Col xs="12">
            <CardQuestion />
          </Col>
        </Row>
      </Container>
    </div>
  );
}
export default Faq;

export const CardQuestion = () => {
  const { t } = useTranslation();
  return (
    <Card className="text-light shadow bg-primary-one border-radius-1">
      <CardBody>
        <Row>
          <Col xs="12" md="12" xl="5" lg="5">
            <CardTitle className="fs-5 text-light pb-3">
              <span className="text-white">
                {" "}
                {t("Did not find the answer to your question?")}
              </span>
            </CardTitle>
            <p className="fs-6 text-light">
              {t("Support_description_first")}
              {t(
                "You can use the following ways to contact us. Our experts will answer you in the shortest possible time."
              )}
            </p>
          </Col>
          <Col sm="12" md="12" xl="7" lg="7">
            <Row className="">
              <Col
                xs="7"
                xl="6"
                lg="6"
                className="d-flex flex-column justify-content-center fs-6 text-light "
              >
                <div className="card-select-br border-1 px-3">
                  <div className="d-flex  align-items-center  pb-3">
                    <i className="icon-phone icon-phone-orange" />
                    <span className="px-2">
                      {isMobile ? t("Call") : t("Contact number: 02147612345")}
                    </span>
                  </div>
                  <div className="d-flex align-items-center pb-3">
                    <i className="icon-linkdin icon-linkdin-orange" />
                    <span className="px-2">{t("Online Chat")}</span>
                  </div>
                  <div className="d-flex align-items-center ">
                    <i className="icon-forum" />
                    <span className="px-2">{t("Send a ticket")}</span>
                  </div>
                </div>
              </Col>
              <Col xs="5" sm="5" md="5" xl="6" lg="6">
                <CardImg
                  src={isMobile ? ContactUs : contact}
                  alt="contact icon"
                  className="card-question-image-style"
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};
